/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
    .factory('FormalizationProposalStatusService', FormalizationProposalStatusService)

  FormalizationProposalStatusService.$inject = ['$resource']

  function FormalizationProposalStatusService ($resource) {
    return $resource('', {}, {
      getProposals: { url: apiUrl + '/formalization-proposal-status/get-proposals', method: 'GET', params: {}, isArray: false },
      resubmitProposal: { url: apiUrl + '/formalization-proposal-status/resubmit-proposal', method: 'POST', params: {}, isArray: false }
    })
  }
// eslint-disable-next-line semi
})();
